"use client";
import { usePathname } from "../use-pathname";
import { NavigationReady } from "./navigation-ready";

export function NavigationFailure() {
  const path = usePathname();
  return (
    <>
      <NavigationReady stage="content" path={path} status="error" />
      <NavigationReady stage="personal" path={path} status="error" />
    </>
  );
}
